import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.slack.ConnectUserPage', {
    pageTitle: 'Authentication',
    footerText: `By allowing access, you agree to the transfer of your data between Slack and ApprovalMax in accordance with <terms>ApprovalMax’s terms of use</terms> and this application's terms of use and privacy policy. You can disconnect this application at any time by going to Account settings in your Slack Settings.`,
    errorConnection: 'Oops, something went wrong.',
    errorAuthStateNotFound: 'Authentication token expired. Please try again.',
    errorUserAlreadyConnected: 'This ApprovalMax user is already connected to another Slack user in this workspace.',
    errorAuthFailed: 'Slack authorization failed.',
    errorPageLoad: 'Page load error.',
    errorAccessDenied: 'Access denied',
    successMessage: 'Access was granted.',
    openSlack: 'Open ApprovalMax in Slack',
});
